import { Reveal } from "./Reveal";

const STATS = [
  { value: "2 & 3", label: "BHK Residences" },
  { value: "5", label: "Residential Towers" },
  { value: "3-Acre", label: "Central Park" },
  { value: "90%", label: "Homes 3-Side Open" },
];

export const StatsStrip = () => (
  <section className="bg-white border-b border-[#DCECC0]" data-testid="stats-strip">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 grid grid-cols-2 lg:grid-cols-4 gap-8">
      {STATS.map((s, i) => (
        <Reveal key={s.label} delay={0.08 * i}>
          <div className="text-center lg:text-left lg:flex lg:items-center lg:gap-5" data-testid={`stat-${i}`}>
            <p className="font-serif-display text-4xl sm:text-5xl text-[#365314] leading-none">{s.value}</p>
            <p className="font-mono-spec text-[10px] sm:text-[11px] tracking-[0.2em] uppercase text-[#65A30D] mt-2 lg:mt-0 lg:max-w-[110px] leading-relaxed">
              {s.label}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
